import 'prismjs/themes/prism-coy.css';
import 'prismjs/plugins/command-line/prism-command-line.css';

import ProviderWrapper from './wrapPageElement';

export const wrapRootElement = ProviderWrapper;
